<template>
  <side-bar
    class="membership-left-sidebar"
    ref="sidebar"
    :sections="sections"
    :title="sidebarTitle"
    @open="setSideOpen"
    @close="setSideClosed"
    logo="GrooveMailLogo"
    id="member-sidebar"
  >
    <template slot="Presets_header">
      <div class="pr-4 flex items-center h-full">
        <gd-button @click="openAddPresetModal" variant="primary" size="icon">
          <PlusIcon class="h-7 w-7" />
        </gd-button>
      </div>
    </template>
    <template slot="Templates">
      <templates-menu
        :templates="templates"
        :activeTemplate="23"
        :updateActiveTemplate="updateActiveTemplate"
      ></templates-menu>
    </template>

    <template slot="Presets">
      <presets-menu></presets-menu>
    </template>
    <template :slot="$t('frontend_settings')">
      <settings-menu></settings-menu>
    </template>
  </side-bar>
</template>
<script>
import SideBar from '@/components/SideBarBuilder';
import TemplatesMenu from './templates/TemplatesMenu';
import SettingsMenu from './settings/SettingsMenu';
import PresetsMenu from './presets/PresetsMenu';

// import icons
import PlusIcon from '@/assets/images/icons/new/plus-small_new.svg';
import TemplatesIcon from '@/assets/images/icons/new/swatchbook_new.svg';
import PresetsIcon from '@/assets/images/icons/new/brush_new.svg';
import SettingsIcon from '@/assets/images/icons/new/settings_new.svg';

export default {
  name: 'ElementsMenu',
  props: {
    substep: {
      required: true,
    },
  },
  components: {
    SettingsMenu,
    TemplatesMenu,
    PresetsMenu,
    PlusIcon,
    SideBar,
  },
  data() {
    return {};
  },
  computed: {
    templates() {
      return true;
    },
    sidebarTitle() {
      return '';
    },
    sections() {
      const sections = [
        {
          name: 'Templates',
          icon: TemplatesIcon,
        },
      ];
      if(this.substep === "design") {
        sections.push({
          name: 'Presets',
          icon: PresetsIcon,
        });
        sections.push({
          name: this.$t('frontend_settings'),
          icon: SettingsIcon,
        });
      }
      return sections;
    },
  },
  methods: {
    openAddPresetModal(){
      this.$root.$emit('modal-open', 'add-preset-modal');
    },
    
    updateActiveTemplate(/* templateId */) {
      /** will be implemented later */
    },
    
    setSideOpen(/* side */) {
      //
    },
    
    setSideClosed(/* side */) {
      //
    },
  },
};
</script>
<style lang="scss">
.mailform-sidebar-loop-group:last-child {
  margin-bottom: 20px;
  .mailform-nav-cus-dropmenu {
    &>.top-0{
      top: auto!important;
      bottom: 10px!important;
    }
  }
}
.membership-left-sidebar {
  z-index: 70;
  top: 45px;
  position: fixed!important;
  left: -8px;
  height: 100vh;
  hr + .uppercase {
    font-size: 16px;
    font-weight: 700;
    position: absolute;
    left: 4px;
    top: -2px;
    text-transform: capitalize;
    & + .h-screen {
      max-height: calc(100vh - 65px);
      padding-bottom: 0;
    }
  }

  &.z-13{
    z-index: 13;
    height: auto;
  }
  svg.auto {
    &.w-6 {
      width: auto;
    }
    &.h-6 {
      height: auto;
    }
  }
}
.membership-left-sidebar {
  &.custom-z-index {
    z-index: 15 !important;
  }
}
</style>
